// src/types/workspaces/Verification.ts
var VerificationStatus = /* @__PURE__ */ ((VerificationStatus2) => {
  VerificationStatus2["Unverified"] = "unverified";
  VerificationStatus2["Pending"] = "pending";
  VerificationStatus2["Verified"] = "verified";
  VerificationStatus2["Rejected"] = "rejected";
  return VerificationStatus2;
})(VerificationStatus || {});
var VerificationSubjectType = /* @__PURE__ */ ((VerificationSubjectType2) => {
  VerificationSubjectType2["Identity"] = "identity";
  VerificationSubjectType2["Business"] = "business";
  return VerificationSubjectType2;
})(VerificationSubjectType || {});
var VerificationDocumentType = /* @__PURE__ */ ((VerificationDocumentType2) => {
  VerificationDocumentType2["IdCardFront"] = "id_card_front";
  VerificationDocumentType2["IdCardBack"] = "id_card_back";
  VerificationDocumentType2["Passport"] = "passport";
  VerificationDocumentType2["Selfie"] = "selfie";
  VerificationDocumentType2["ProofOfAddress"] = "proof_of_address";
  VerificationDocumentType2["BusinessRegistration"] = "business_registration";
  VerificationDocumentType2["CertificateOfIncorporation"] = "certificate_of_incorporation";
  VerificationDocumentType2["TaxCard"] = "tax_card";
  VerificationDocumentType2["Other"] = "other";
  return VerificationDocumentType2;
})(VerificationDocumentType || {});
var IDENTITY_DOCUMENT_TYPES = [
  "id_card_front" /* IdCardFront */,
  "id_card_back" /* IdCardBack */,
  "passport" /* Passport */,
  "selfie" /* Selfie */,
  "proof_of_address" /* ProofOfAddress */,
  "other" /* Other */
];
var BUSINESS_DOCUMENT_TYPES = [
  "business_registration" /* BusinessRegistration */,
  "certificate_of_incorporation" /* CertificateOfIncorporation */,
  "tax_card" /* TaxCard */,
  "proof_of_address" /* ProofOfAddress */,
  "other" /* Other */
];
var VerificationDocumentStatus = /* @__PURE__ */ ((VerificationDocumentStatus2) => {
  VerificationDocumentStatus2["Active"] = "active";
  VerificationDocumentStatus2["PendingRemoval"] = "pending_removal";
  return VerificationDocumentStatus2;
})(VerificationDocumentStatus || {});
var VerificationDocumentReviewStatus = /* @__PURE__ */ ((VerificationDocumentReviewStatus2) => {
  VerificationDocumentReviewStatus2["Pending"] = "pending";
  VerificationDocumentReviewStatus2["Approved"] = "approved";
  VerificationDocumentReviewStatus2["Rejected"] = "rejected";
  return VerificationDocumentReviewStatus2;
})(VerificationDocumentReviewStatus || {});
var IdentityVerificationProvider = /* @__PURE__ */ ((IdentityVerificationProvider2) => {
  IdentityVerificationProvider2["Manual"] = "manual";
  IdentityVerificationProvider2["Didit"] = "didit";
  return IdentityVerificationProvider2;
})(IdentityVerificationProvider || {});
var VerificationDecision = /* @__PURE__ */ ((VerificationDecision2) => {
  VerificationDecision2["Approved"] = "approved";
  VerificationDecision2["Rejected"] = "rejected";
  return VerificationDecision2;
})(VerificationDecision || {});
var DocumentRemovalDecision = /* @__PURE__ */ ((DocumentRemovalDecision2) => {
  DocumentRemovalDecision2["Confirm"] = "confirm";
  DocumentRemovalDecision2["Reject"] = "reject";
  return DocumentRemovalDecision2;
})(DocumentRemovalDecision || {});
var VERIFICATION_EDITABLE_STATUSES = [
  "unverified" /* Unverified */,
  "pending" /* Pending */,
  "rejected" /* Rejected */
];
var isVerificationEditable = (status) => VERIFICATION_EDITABLE_STATUSES.includes(status);
var VERIFICATION_DETAILS_EDITABLE_STATUSES = [
  "unverified" /* Unverified */,
  "rejected" /* Rejected */
];
var isVerificationDetailsEditable = (status) => VERIFICATION_DETAILS_EDITABLE_STATUSES.includes(status);
var VERIFICATION_STATUS_META = {
  ["unverified" /* Unverified */]: { tone: "secondary" },
  ["pending" /* Pending */]: { tone: "warning" },
  ["verified" /* Verified */]: { tone: "success" },
  ["rejected" /* Rejected */]: { tone: "destructive" }
};
var VERIFICATION_DOC_REVIEW_META = {
  ["pending" /* Pending */]: { tone: "warning" },
  ["approved" /* Approved */]: { tone: "success" },
  ["rejected" /* Rejected */]: { tone: "destructive" }
};
var IDENTITY_DOCUMENT_SLOTS = [
  { type: "id_card_front" /* IdCardFront */ },
  { type: "id_card_back" /* IdCardBack */ },
  { type: "passport" /* Passport */ },
  { type: "selfie" /* Selfie */ },
  { type: "proof_of_address" /* ProofOfAddress */ }
];
var BUSINESS_DOCUMENT_SLOTS = [
  { type: "business_registration" /* BusinessRegistration */ },
  { type: "certificate_of_incorporation" /* CertificateOfIncorporation */ },
  { type: "tax_card" /* TaxCard */ },
  { type: "proof_of_address" /* ProofOfAddress */ }
];

export {
  VerificationStatus,
  VerificationSubjectType,
  VerificationDocumentType,
  IDENTITY_DOCUMENT_TYPES,
  BUSINESS_DOCUMENT_TYPES,
  VerificationDocumentStatus,
  VerificationDocumentReviewStatus,
  IdentityVerificationProvider,
  VerificationDecision,
  DocumentRemovalDecision,
  VERIFICATION_EDITABLE_STATUSES,
  isVerificationEditable,
  VERIFICATION_DETAILS_EDITABLE_STATUSES,
  isVerificationDetailsEditable,
  VERIFICATION_STATUS_META,
  VERIFICATION_DOC_REVIEW_META,
  IDENTITY_DOCUMENT_SLOTS,
  BUSINESS_DOCUMENT_SLOTS
};
